import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@backoffice-frontend/shared/directives/common';
import { type SettingSpotConfiguration } from '@clean-code/models';
import { indicate } from '@clean-code/shared/common';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import {
    TableStateService,
    UiMatTableModule,
} from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { TranslocoModule } from '@jsverse/transloco';
import { startWith, switchMap } from 'rxjs/operators';
import { SettingSpotConfigurationService } from '../../services/setting-spot-configuration.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'backoffice-frontend-setting-spot-configuration-list',
  templateUrl: './setting-spot-configuration-list.component.html',
  imports: [
    CommonModule,
    RouterModule,
    UiMatTableModule,
    TranslocoModule,
    MatCheckboxModule,
    DirectivesModule,
    PageContainerModule,
    ActionButtonModule,
  ],
  providers: [TableStateService],
})
export class SettingSpotConfigurationListComponent extends DataTableBaseComponent<SettingSpotConfiguration> {
  protected override navigateUrl = '/spotConfigurations';
  public loading = true;
  public settingSpotConfigurations$ =
    this.tableStateService.refreshTrigger$.pipe(
      startWith(null),
      switchMap((_) =>
        this.settingSpotConfigurationService
          .getAllSettingSpotConfigurations$()
          .pipe(indicate(this.isLoading$)),
      ),
    );

  constructor(
    private settingSpotConfigurationService: SettingSpotConfigurationService,
  ) {
    super(settingSpotConfigurationService);
  }
}
